import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { getCandidate, getCandidateNote } from 'selectors/candidates';
import useModal from 'hooks/useModal';
import useCandidates from './useCandidates';
import { getUserCandidate } from '../actions';

const useCandidateDetails = (candidateId: number) => {
  const { role } = useSelector<any, any>(state => state.user);
  const { openModalHandler } = useModal();

  const dispatch = useDispatch();

  const getUserCandidateHandler = useCallback(id => dispatch(getUserCandidate({ id })), [dispatch]);

  useEffect(() => {
    getUserCandidateHandler(candidateId);
  }, [getUserCandidateHandler, candidateId]);

  const candidate = useSelector<any, any>((state: any) => getCandidate(state, candidateId));

  const candidateNote = useSelector<any, any>((state: any) => getCandidateNote(state, candidateId));

  const messagesCounter = useSelector<any, any>(state => state.messages.length);

  const { downloadAttachedFileHandler } = useCandidates(candidate && candidate.id);

  return {
    role,
    candidate,
    openModalHandler,
    candidateNote,
    messagesCounter,
    downloadAttachedFileHandler,
  };
};

export default useCandidateDetails;
